export function verificationLinkCode(search: string): string | null {
  const params = new URLSearchParams(search);
  const email = (params.get("email") ?? "").trim();
  const code = (params.get("code") ?? "").trim();
  if (email === "" || code === "") return null;
  return code;
}

export function claimVerificationLink(
  search: string,
  claimed: Set<string>,
): string | null {
  const code = verificationLinkCode(search);
  if (code === null) return null;
  const email = (new URLSearchParams(search).get("email") ?? "").trim();
  const key = `${email}\n${code}`;
  if (claimed.has(key)) return null;
  claimed.add(key);
  return code;
}
